
































import { Component, Vue, Watch } from "vue-property-decorator";
import { SalonHistory } from "@/models/salon_history";
import SalonTipComponent from "@/components/SalonTipComponent.vue";
import SystemConst from "@/config/const";
import SalonFavoriteService from "@/services/SalonFavoriteService";

@Component({
  name: "SalonFavoriteApp",
  components: {
    SalonTipComponent,
  },
})
export default class SalonFavoriteApp extends Vue {
  // salonFavoritesとSalonHistoryは同じ型を持つ
  selectedSalonType = SystemConst.SALON_TYPE_ALL;
  salonType = SystemConst.SALON_TYPE;
  page = 1;
  perPage = 10;
  salons = [];
  readMore = false;
  isLoadingMore = false;

  unFav(id: number) {
    const index = this.salons.findIndex((salon: any) => salon.id === id);
    if (index >= 0) this.salons.splice(index, 1);
  }

  async getMore() {
    if (this.isLoadingMore) return;
    this.isLoadingMore = true;
    this.page += 1;
    await this.fetchSalonFavorite();
    this.isLoadingMore = false;
  }

  public async created() {
    this.fetchSalonFavorite();
  }

  async fetchSalonFavorite(changeType = false) {
    const query = {
      page: this.page,
      per_page: this.perPage,
      salon_genre: this.selectedSalonType,
    };
    const {
      data: { salon_favorites, read_more },
    } = await SalonFavoriteService.getSalons(query);
    this.readMore = read_more;
    if (changeType) {
      this.salons = salon_favorites;
    } else {
      this.salons = this.salons.concat(salon_favorites);
    }
  }

  public mounted() {
    document.title =
      "お気に入りサロン一覧 | favsalon(ファブサロン) | 再来率を向上させるサロンに特化したネットショップサービス";
    const descriptonMeta = document.querySelector("meta[name='description']");
    if (descriptonMeta) {
      descriptonMeta.setAttribute(
        "content",
        "お気に入りサロン一覧 | favsalon（ファブサロン）なら美容室やネイルサロン、リラクサロンなどのサロンメニューに特化したネットサロンを簡単に作ることができます。シークレットメニューで来店者のみに販売するサービスを作って再来率を向上させます！"
      );
    }
    const robotsMeta = document.querySelector("meta[name='robots']");
    if (robotsMeta) {
      robotsMeta.setAttribute("content", "noindex");
    }
  }

  @Watch("selectedSalonType", { deep: true })
  onSelectedSalonTypeChanged() {
    this.page = 1;
    this.fetchSalonFavorite(true);
  }
}
